
































































































































import { Component, Vue } from 'vue-property-decorator'
import router from '../../router'
import buyApi from '@/api/buyApi'
import moment from 'moment'
import CountDown from '@/components/ui/CountDown.vue'
import cartsApi from '@/api/cartsApi'

@Component({
  components: {
    CountDown,
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY年MM月DD日')
    }
  }
})
export default class ChoiceTime extends Vue {
  public lockSpinning?: boolean = false;
  private checkGoods: string = ''
  private sortValue: string = 'DEFAULT'
  private ridioId: string = ''
  private isChoice: boolean = false
  private tradeSize: string = ''
  private tradeType: string = 'SCHEDULE'
  private noCountDown: string = 'noCountDown'
  private immediatelyBuyLoading: boolean = false // 立即下单 loading
  private res: any = [
    // {
    //   details: [
    //     {
    //       minSellPrice: 12,
    //       orderScheduleStatus: 'NORMAL',
    //       ownerName: '四川省管理公司',
    //       provinceCode: 23,
    //       provinceName: '四川省',
    //       resourceMargin: 23,
    //       scheduleEndTime: 124312432,
    //       scheduleStartTime: 12341341,
    //       selectableChannels: 32,
    //       tradeUnit: '金币/SKU/店',
    //     }
    //   ],
    //   minSellPrice: '132',
    //   orderScheduleStatus: 'NORMAL',
    //   scheduleEndTime: 124312432,
    //   scheduleStartTime: 12341341,
    //   sellNum: 123,
    //   sellProvince: '四川，重庆',
    //   step: 2,
    //   tradeUnit: '金币/SKU/店',
    //   id: 21,
    //   itemShow: false,
    //   saleDataId: '2123'
    // },
    // {
    //   details: [
    //     {
    //       minSellPrice: 12,
    //       orderScheduleStatus: 'NORMAL',
    //       ownerName: '四川省管理公司',
    //       provinceCode: 2332,
    //       provinceName: '四川省',
    //       resourceMargin: 23,
    //       scheduleEndTime: 124312432,
    //       scheduleStartTime: 12341341,
    //       selectableChannels: 32,
    //       tradeUnit: '金币/SKU/店',

    //     },
    //     {
    //       minSellPrice: 12,
    //       orderScheduleStatus: 'NORMAL',
    //       ownerName: '四川省管理公司',
    //       provinceCode: 233322,
    //       provinceName: '四川省',
    //       resourceMargin: 23,
    //       scheduleEndTime: 124312432,
    //       scheduleStartTime: 12341341,
    //       selectableChannels: 32,
    //       tradeUnit: '金币/SKU/店',
    //       saleDataId: '212223'
    //     }
    //   ],
    //   minSellPrice: '132',
    //   orderScheduleStatus: 'NORMAL',
    //   scheduleEndTime: 124312432,
    //   scheduleStartTime: 12341341,
    //   sellNum: 123,
    //   sellProvince: '四川，重庆',
    //   step: 2,
    //   tradeUnit: '金币/SKU/店',
    //   id: 21232,
    //   itemShow: false
    // }
  ]

  private req: any = {
    provinceCodes: [],
    resourceId: '',
    saleDataId: ''
  }

  private selectList: any[] = [
    { name: '默认排序', value: 'DEFAULT', id: 1 },
    { name: '价格排序', value: 'PRICE', id: 2 },
    // { name: '热门排序', value: 'HOT', id: 3 },
  ]

  public mounted(): void {
    this.getList()
  }

  private getList() {
    buyApi.choiceTime({
      resourceId: this.$route.query.id,
      sort: this.sortValue,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
      if (res.code === 200) {
        this.res = res.data
        res.data[0].tradeSize === 'STORE' ? this.tradeSize = 'STORE' : this.tradeSize = 'PLATFORM'
        res.data[0].tradeType === 'SCHEDULE' ? this.tradeType = 'SCHEDULE' : this.tradeType = 'CYCLETIME'
      } else {
        this.$warning({
          title: '提示',
          content: res.msg
        });
      }
    })
  }

  // 排序
  protected handleChange(value: any): void {
    this.sortValue = value
    this.getList()
  }

  // 点击单选按钮
  protected changeStatus(status: any) {
    this.req.provinceCodes = []
    this.req.saleDataId = status.target.value
  }

  // 进入下一步
  protected next(): void {
    if (this.req.provinceCodes.length <= 0) {
      this.$warning({
        title: '提示',
        content: '请选择了档期再进入下一步',
      });
      return
    }
    let parame = {
      provinceCodes: this.req.provinceCodes,
      saleDataId: this.req.saleDataId,
      resourceId: this.$route.query.id,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }
    buyApi.submitTime(parame).then((res) => {
      if (res.code === 200 && res.data) {
        const step: string = '3';
        router.push({ name: 'buy', query: { step, id: this.$route.query.id, stepStatus: this.$route.query.stepStatus, tradeSize: this.$route.query.tradeSize } })
      } else {
        this.$message.warning(res.msg)
      }
    })
  }


  // 跳过选择渠道下单 
  protected immediatelyBuy() {
    if (this.req.provinceCodes.length <= 0) {
      this.$warning({
        title: '提示',
        content: '请选择了档期再进入下一步',
      });
      return
    }
    let parame = {
      provinceCodes: this.req.provinceCodes,
      saleDataId: this.req.saleDataId,
      resourceId: this.$route.query.id,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }
    this.immediatelyBuyLoading = true;
    buyApi.submitTime(parame).then((res) => {
      if (res.code === 200 && res.data) {
        buyApi.buy({
          resouceId: this.$route.query.id,
          orderCommitEnum: 'SHOPING',
          operType: 0,
          uniqueKey:sessionStorage.getItem('uniqueKey')
        }).then((res) => {
          this.immediatelyBuyLoading = false;
          if (res.code === 200 && res.data) {
            this.lockSpinning = true;
            this.locked({orderCode: res.data.orderCode},() => {
              this.lockSpinning = false;
              const step = '4'
              router.push({ name: 'buy', query: { step, id: this.$route.query.id, stepStatus: this.$route.query.stepStatus, tradeSize: this.$route.query.tradeSize, orderCode: res.data.orderCode } })
            })
          } else {
            this.$message.warning(res.msg);
            this.immediatelyBuyLoading = false;
          }
        })
      }
    })
  }

  // 锁定库存
  public locked(data?: any,callback?: ()=>void) {
    buyApi.locked(data).then((res)=>{
      if(res.code==200 && res.data.orderLockStatusEnum == 1){
        callback ? callback() : '';
      } else {
        setTimeout(() => {
          this.locked(data,callback);
        }, 1000)
      }
    })
  }

  // 跳过选择渠道添加到购物车
  protected addCart() {
    if (this.req.provinceCodes.length <= 0) {
      this.$warning({
        title: '提示',
        content: '请选择了档期再进入下一步',
      });
      return
    }
    let parame = {
      provinceCodes: this.req.provinceCodes,
      saleDataId: this.req.saleDataId,
      resourceId: this.$route.query.id,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }
    buyApi.submitTime(parame).then((res) => {
      if (res.code === 200 && res.data) {
        buyApi.addCarts({
          orderCommitEnum: 'SHOPING',
          resouceId: this.$route.query.id,
          operType: 0
        }).then((res) => {
          if (res.code === 200) {
              this.getCarts()
              router.push({ name: 'carts' })
          } else {
            this.$message.warning(res.msg)
          }
        })
      }
    })
  }
 
 // 获取购物车
  protected getCarts() {
    if (localStorage.getItem('token')) {
      cartsApi.getCartsList({
      }).then((res) => {
        if (res.code === 200) {
          let cartsLenth = res.data.length
          this.$store.commit('changeCartsAmount', cartsLenth)
        }
      })
    }
  }
}
